import React, { useEffect, useState, useContext } from 'react';
import { Container, TextField, Button, MenuItem, Typography, Alert } from '@mui/material';
import userApi from '../../api/userApi';
import contribuenteApi from '../../api/contribuenteApi';
import { useParams, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../auth/AuthContext';

const profiles = ['CONTRIBUENTE', 'STUDIO', 'ADMIN'];

export default function UtenteEditPage() {
  const { id } = useParams();
  const [form, setForm] = useState(null);
  const [err, setErr] = useState(null);
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const [contribuenteutente, setContribuenteutente] = useState(null);
  const [contribuenti, setContribuenti] = useState([]);
  const [selcontribuente, setSelcontribuente] = useState('');

  // Caricamento dati utente e lista contribuenti
  useEffect(() => {
    userApi.get(id)
      .then(r => setForm(r.data))
      .catch(e => setErr(e.response?.data || e.message));

    fetchContribuenti();
  }, [id]);

  const fetchContribuenti = async () => {
    if (!user) return;

    try {
      const res = await contribuenteApi.listnotassociated();
      setContribuenti(res.data || []);

      const utenteRes = await contribuenteApi.getbyuserid(id);
      if (utenteRes.data) {
        setContribuenteutente(utenteRes.data);
        setSelcontribuente(utenteRes.data.id);
        setMessage(`Associato al contribuente ${utenteRes.data.cognome} ${utenteRes.data.nome}`);
      } else {
        setContribuenteutente(null);
        setSelcontribuente('');
        setMessage(null);
      }
    } catch (e) {
      console.error(e);
      setErr('Errore nel caricamento dei contribuenti');
    }
  };

  const associaContribuente = async (contribuenteId) => {
    const contribuente = contribuenti.find(c => c.id === contribuenteId);
    if (!contribuente) return;

    try {
      contribuente.utenteId = form.id;
      await contribuenteApi.update(contribuente.id, contribuente);
      setSelcontribuente(contribuente.id);
      setContribuenteutente(contribuente);
      setMessage(`L'utente è stato associato al contribuente ${contribuente.cognome} ${contribuente.nome}`);
    } catch (e) {
      setErr(e.response?.data || e.message);
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    try {
      await userApi.update(id, form);
      navigate(`/users/${id}`);
    } catch (e) {
      setErr(e.response?.data || e.message);
    }
  };

  if (!form) return <div>Loading...</div>;

  return (
    <Container>
      <Typography variant="h5" sx={{ mb: 2 }}>Modifica Utente</Typography>

      {message && <Alert sx={{ mb: 2 }}>{message}</Alert>}
      {err && <Alert severity="error" sx={{ mb: 2 }}>{typeof err === 'string' ? err : JSON.stringify(err)}</Alert>}

      <form onSubmit={submit}>

        <TextField
          select
          fullWidth
          sx={{ my: 1 }}
          label="Associa Contribuente"
          value={selcontribuente}
          onChange={e => associaContribuente(e.target.value)}
        >
          {contribuenti.map(c =>
            <MenuItem key={c.id} value={c.id}>{c.cognome} {c.nome}</MenuItem>
          )}
        </TextField>
        <TextField
          fullWidth
          sx={{ my: 1 }}
          label="Username"
          value={form.username}
          onChange={e => setForm({ ...form, username: e.target.value })}
        />
        <TextField
          fullWidth
          sx={{ my: 1 }}
          label="Email"
          value={form.email}
          onChange={e => setForm({ ...form, email: e.target.value })}
        />
        <TextField
          select
          fullWidth
          sx={{ my: 1 }}
          label="Profile"
          value={form.profile}
          onChange={e => setForm({ ...form, profile: e.target.value })}
        >
          {profiles.map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}
        </TextField>


        <Button variant="contained" type="submit" sx={{ mt: 1 }}>Salva</Button>
      </form>

      {/* CREA / VISUALIZZA CONTRATTO */}
      {form.contrattoId == null ? (
        <Button
          variant="contained"
          sx={{ mt: 2 }}
          onClick={() => navigate(`/contratti/create?utenteId=${id}&redirect=/users/${id}/edit`)}
        >
          Crea Contratto
        </Button>
      ) : (
        <Button
          variant="contained"
          sx={{ mt: 2 }}
          onClick={() => navigate(`/contratti/${form.contrattoId}`)}
        >
          Visualizza Contratto
        </Button>
      )}
    </Container>
  );
}